import { useState, useRef } from 'react';
import { getInitialValuesFromSteps, type IWizardStep } from '../utils/form';
import settings from '../config/settings';

interface IUseFormValuesRefOptions<TValues> {
  formValueMock: Partial<TValues>;
  initialValues: TValues;
}

/** A ref with the wizard's form values, initialised once (with the mock values in development). */
export default function useFormValuesRef<TValues extends object>(
  wizardSteps: IWizardStep[],
  { formValueMock, initialValues }: IUseFormValuesRefOptions<TValues>,
) {
  // Computed on the first render only, as the former `if (!formValuesRef.current)` did.
  const [firstValues] = useState(() => ({
    ...getInitialValuesFromSteps(wizardSteps),
    // ...initialValues,
    ...(settings.isDevelopment ? { ...initialValues, ...formValueMock } : initialValues),
  }));
  const formValuesRef = useRef<TValues>(firstValues);
  return formValuesRef;
}
